import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { measureSms } from "../lib/common/smsSegments";

const SmsCost = React.memo(
  ({
    value,
    withLink,
  }: {
    value?: string | null;
    withLink?: string | null;
  }) => {
    const { t } = useTranslation(["client"]);

    const base = useMemo(() => measureSms(value), [value]);
    const linked = useMemo(() => measureSms(withLink), [withLink]);

    if (!base.characters) {
      return null;
    }

    const isUcs2 = base.encoding === "UCS-2";

    const segments = linked.segments || base.segments;

    return (
      <div className="mt-3">
        <div className="d-flex flex-wrap align-items-center">
          <span
            className={`badge mr-1 mb-1 px-3 py-2 badge-${
              segments > 1 ? "warning" : "success"
            }`}
          >
            {t("client:client.twilioMessage.cost.segments", {
              count: base.segments,
            })}
          </span>
          <span className="badge badge-light border mr-1 mb-1 px-3 py-2">
            {t("client:client.twilioMessage.cost.characters", {
              count: base.characters,
            })}
          </span>
          <span
            className={`badge border mr-1 mb-1 px-3 py-2 ${
              isUcs2 ? "badge-warning" : "badge-light"
            }`}
          >
            {base.encoding}
          </span>
          {!!linked.characters && (
            <span className="badge badge-light border mr-1 mb-1 px-3 py-2">
              {t("client:client.twilioMessage.cost.withLinks", {
                characters: linked.characters,
                count: linked.segments,
              })}
            </span>
          )}
        </div>
        {isUcs2 && (
          <div className="small text-warning">
            {t("client:client.twilioMessage.cost.ucs2", {
              characters: base.offenders.join(" "),
            })}
          </div>
        )}
        <div className="small text-muted">
          {t("client:client.twilioMessage.cost.variables")}
        </div>
      </div>
    );
  },
);

export default SmsCost;
